import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles<Theme>(({ palette, spacing, typography }) => ({
  nameCell: {
    ...typography.body1,
    textAlign: "center",
    borderRight: `1px solid ${palette.divider}`,
  },
  dayHeaderCell: {
    textAlign: "center",
    ...typography.body2,
    borderRight: `1px solid ${palette.divider}`,
    padding: spacing(1, 2),
    "&:last-child": {
      borderRight: "none",
    },
  },
  emptyHeaderCell: {
    borderRight: `1px solid ${palette.divider}`,
  },
  bodyCell: {
    borderRight: `1px solid ${palette.divider}`,
    padding: spacing(3, 3),
    "&:last-child": {
      borderRight: "none",
    },
  },
}));

export default useStyles;
